import { api } from "./client";
import type { ApiEnvelope, AuthTokens } from "./types";

/** EMAIL when the identifier looks like an email address, else SMS. */
export function channelFor(identifier: string): "EMAIL" | "SMS" {
  return identifier.includes("@") ? "EMAIL" : "SMS";
}

export const authApi = {
  requestOtp: (body: { identifier: string; locale?: string }) =>
    api.post<ApiEnvelope<null>>("/api/v1/auth/otp/request", {
      identifier: body.identifier,
      channel: channelFor(body.identifier),
      locale: body.locale ?? "en",
    }),

  verifyOtp: (body: { identifier: string; code: string }) => {
    const isEmail = body.identifier.includes("@");
    return api.post<ApiEnvelope<AuthTokens>>("/api/v1/auth/otp/verify", {
      identifier: body.identifier,
      code: body.code,
      email: isEmail ? body.identifier : undefined,
      phoneE164: isEmail ? undefined : body.identifier,
    });
  },

  refresh: (refreshToken: string) =>
    api.post<ApiEnvelope<AuthTokens>>("/api/v1/auth/token/refresh", null, {
      headers: { "X-Refresh-Token": refreshToken },
    }),

  me: () => api.get<ApiEnvelope<AuthTokens>>("/api/v1/auth/me"),
};
